module.exports = new __parcel__URL__("PRD.b38857d1.svg").toString();